import styled from 'styled-components'

const Trophy = styled('img')`
  z-index: 1;
`

export default Trophy
